var clickpostForm = document.querySelector(".clickpost-edd__form");
var submitButton = document.querySelector(".clickpost-edd__submit-button");
var responseEddText = document.getElementById("response-edd-text").innerHTML;
// var responseCodText = document.getElementById("response-cod-text").innerHTML;
var month = clickpostForm.querySelector('input[name="month"]').value;
var dateFormat = clickpostForm.querySelector('input[name="date_format"]').value;
var cutoffTime = clickpostForm.querySelector('input[name="cutoff_time"]') ? clickpostForm.querySelector('input[name="cutoff_time"]').value : '24';
var cpCountdownElement = document.getElementById('countdown');
const now = new Date();
const targetHours = cutoffTime;
const targetTimeToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), targetHours).getTime();
if (cpCountdownElement) {
  const countdownInterval = setInterval(() => {
    const currentTime = new Date().getTime();
    const timeRemaining = targetTimeToday - currentTime;
    if (timeRemaining > 0) {
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000).toString().padStart(2, '0');
      cpCountdownElement.innerHTML = `Order within <span style='color:red'>${hours}:${minutes}:${seconds}</span>`;
    } else {
      cpCountdownElement.innerHTML = '00:00:00';
      clearInterval(countdownInterval); // Stop the countdown
    }
  }, 1000);
}
var monthMap = [];
if (month == 'false') {
  monthMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
}
else {
  monthMap = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
}
const nth = function (d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}

if(submitButton){
  submitButton.addEventListener("click", (event) => {
    event.preventDefault();
    fetchEdd();
  });
}

var inputElementEnter = clickpostForm.querySelector('input[name="drop_pincode"]');
inputElementEnter.addEventListener('keyup', function (e) {

  if (e.key === 'Enter' || e.keyCode === 13 || inputElementEnter.value.length == 6) {
    event.preventDefault();
    fetchEdd();
  }
});
const fetchEdd = () => {
  var submitButton = document.querySelector(".clickpost-edd__submit-button");
  if(submitButton){
    submitButton.classList.toggle("button--loading");
    submitButton.disabled = true;
  }
  
  var cod = false;
  var responseFail = document.getElementById("response-error");
  var responseSuccess = document.getElementById("response-success");
  responseFail.style.display = "none";
  responseSuccess.style.display = "none";
  document.getElementById("response-hide").style.display = "none";
  var dropPincode = clickpostForm.querySelector('input[name="drop_pincode"]').value;
  var productId = clickpostForm.querySelector('input[name="product_id"]').value;
  if (dropPincode.length != 6 || !/^\d+$/.test(dropPincode)) {
    responseFail.style.color = "red";
    responseFail.innerHTML = document.getElementById("response-invalid-text").innerHTML;
    responseSuccess.style.display = "none";
    responseFail.style.display = "block";
    if(submitButton){
      submitButton.classList.toggle("button--loading");
      submitButton.disabled = false;
    }
    
    return false;
  }
  var pickupPincode = clickpostForm.querySelector('input[name="pickup_pincode"]').value;
  var method = clickpostForm.querySelector('input[name="method"]').value;
  var standardEdd = clickpostForm.querySelector('input[name="standard_edd"]').value;
  var productEdd = clickpostForm.querySelector('input[name="product_edd"]') ? clickpostForm.querySelector('input[name="product_edd"]').value : 0;
  var collectionEdd = clickpostForm.querySelector('input[name="collection_edd"]') ? clickpostForm.querySelector('input[name="collection_edd"]').value : 0;
  var dateRange = clickpostForm.querySelector('input[name="date_range"]').value;
  var vendorEdd = clickpostForm.querySelector('input[name="vendor_edd"]') ? clickpostForm.querySelector('input[name="vendor_edd"]').value : 0;
  var logic = clickpostForm.querySelector('input[name="logic"]') ? clickpostForm.querySelector('input[name="logic"]').value : false;
  if (logic && logic == 'static') {
    sessionStorage.setItem("drop_pincode", dropPincode);
    var minstatic = clickpostForm.querySelector('input[name="minstatic"]') ? clickpostForm.querySelector('input[name="minstatic"]').value : 0;
    var maxstatic = clickpostForm.querySelector('input[name="maxstatic"]') ? clickpostForm.querySelector('input[name="maxstatic"]').value : 0;
    cod = true;
    responseFail.style.display = "none";
    responseSuccess.style.display = "block";
    var finalEdd = '';
    var date = Date.now();
    var dateCurrent = new Date(date);
    var afterCutoff = (dateCurrent.getHours() + 1) > parseInt(cutoffTime) ? true : false;
    var max = parseInt(maxstatic) + parseInt(standardEdd) + parseInt(productEdd) + parseInt(collectionEdd) + parseInt(vendorEdd);
    console.log(max)
    if (afterCutoff) max = max + 1;
    max = new Date(date + parseInt(max * 86400000));
    var maxDate = max.getDate();
    var min = parseInt(minstatic) + parseInt(standardEdd) + parseInt(productEdd) + parseInt(collectionEdd) + parseInt(vendorEdd);
    min = new Date(date + parseInt(min * 86400000));
    var minDate = min.getDate();
    if (dateRange == 'true') {
      if (min.getMonth() == max.getMonth()) finalEdd = `<b>` + minDate + '<sup>' + nth(minDate) + '</sup>' + ` and ` + maxDate + "<sup>" + nth(maxDate) + "</sup>" + ' ' + monthMap[max.getMonth()] + `</b>`;
      if (afterCutoff) min = min + 1;
      else finalEdd = `<b>` + minDate + '<sup>' + nth(minDate) + '</sup>' + ' ' + monthMap[min.getMonth()] + ` and ` + maxDate + "<sup>" + nth(maxDate) + "</sup>" + ' ' + monthMap[max.getMonth()] + `</b>`;
    }
    else {
      finalEdd = `<b>` + minDate + '<sup>' + nth(minDate) + '</sup>' + ' ' + monthMap[min.getMonth()] + `</b>`;
    }
    const responseEDD = document.getElementById("response-edd");
    responseEDD.innerHTML = responseEddText + " " + finalEdd;
    cod = cod ? '<span style="color:green">available</span>' : '<span style="color:red">not available</span>';
    // document.getElementById("response-cod").innerHTML = responseCodText + " " + cod;
    if(submitButton){
      submitButton.classList.toggle("button--loading");
      submitButton.disabled = false;
    }
    return false;
  }
  sessionStorage.setItem("drop_pincode", dropPincode);
  fetch(
    "/apps/clickpost-edd-proxy/availability",
    {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify([
        {
          dropPincode: dropPincode,
          pickupPincode: pickupPincode,
          productId: productId,
          method: method
        },
      ]),
    }
  )
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.length > 0) {
        cod = true;
        fetch(
          "/apps/clickpost-edd-proxy/edd",
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify([
              {
                dropPincode: dropPincode,
                pickupPincodes: data,
                productId: productId,
                method: method
              },
            ]),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log(data)
            responseFail.style.display = "none";
            responseSuccess.style.display = "block";
            var finalEdd = '';
            var date = Date.now();
            var dateCurrent = new Date(date);
            var afterCutoff = parseInt(cutoffTime) !== 0 && (dateCurrent.getHours() + 1) > parseInt(cutoffTime);
            var max = data.result[0].predicted_sla_max + parseInt(standardEdd) + parseInt(productEdd) + parseInt(collectionEdd) + parseInt(vendorEdd);
            if (afterCutoff) max = max + 1;
            max = new Date(date + parseInt(max * 86400000));
            var maxDate = max.getDate();
            var min = data.result[0].predicted_sla_min + parseInt(standardEdd) + parseInt(productEdd) + parseInt(collectionEdd) + parseInt(vendorEdd);
            if (afterCutoff) min = min + 1;
            min = new Date(date + parseInt(min * 86400000));

            console.log({min, cutoffTime}, min.getFullYear())
            var minDate = min.getDate();
            if (dateRange == 'true') {
              if (min.getMonth() == max.getMonth()) finalEdd = `<b>` + minDate + '<sup>' + nth(minDate) + '</sup>' + ` and ` + maxDate + "<sup>" + nth(maxDate) + "</sup>" + ' ' + monthMap[max.getMonth()] + `</b>`;
              else finalEdd = `<b>by` + minDate + '<sup>' + nth(minDate) + '</sup>' + ' ' + monthMap[min.getMonth()] + ` and ` + maxDate + "<sup>" + nth(maxDate) + "</sup>" + ' ' + monthMap[max.getMonth()] + `</b>`;
            }
            else {
              var minYear = min.getFullYear();
              finalEdd = `<b>by ` + minDate + '<sup>' + nth(minDate) + '</sup>' + ' ' + monthMap[min.getMonth()] + ' ' + minYear + `</b> <span id="countdown"></span>`;
            }
            const responseEDD = document.getElementById("response-edd");
            responseEDD.innerHTML = responseEddText + " " + finalEdd;
            if (cpCountdownElement) {
              cpCountdownElement.style.display = "block";
            }
            cod = cod ? '<span style="color:green">available</span>' : '<span style="color:red">not available</span>';
            // document.getElementById("response-cod").innerHTML = responseCodText + " " + cod;
            if(submitButton){
              submitButton.classList.toggle("button--loading");
              submitButton.disabled = false;
            }
          })
          .catch((error) => {
            if(submitButton){
              submitButton.classList.toggle("button--loading");
              submitButton.disabled = false;
            }
            responseFail.style.display = "block";
            responseFail.innerHTML = `Unable to retrieve estimated delivery date.`;
            console.log(error);
          });
      } else {
        if(submitButton){
          submitButton.classList.toggle("button--loading");
          submitButton.disabled = false;
        }
        responseSuccess.style.display = "none";
        responseFail.style.display = "block";
        responseFail.innerHTML = `Pincode not servicable`;
      }
    })
    .catch((error) => {
      if(submitButton){
        submitButton.classList.toggle("button--loading");
        submitButton.disabled = false;
      }
      responseFail.style.display = "block";
      responseFail.innerHTML = `Unable to retrieve estimated delivery date.`;
      console.log(error);
    });
}
window.addEventListener("load", (event) => {
  const dropPincode = sessionStorage.getItem("drop_pincode");
  if (dropPincode) {
    clickpostForm.querySelector('input[name="drop_pincode"]').value = dropPincode;
    fetchEdd();
  }
});